import { CONSTANTS } from '../config/constants';

document.addEventListener('DOMContentLoaded', () => {
	if (document.getElementById('point-picker')) {
		let map = new mapboxgl.Map({
			container: 'point-picker',
			style: CONSTANTS.map_style,
			center: CONSTANTS.map_center,
			zoom: 16,
			minZoom: 13,
			maxZoom: 20,
			maxBounds: [
				[-89.6, 42.96],
				[-89.3, 43.2],
			],
			scrollZoom: true,
			pitchWithRotate: false,
			dragRotate: false,
			hash: false,
			trackResize: true,
		});

		// Define the blank marker
		let marker = false;
		const map_object = W.map_object;

		// marker highlighting dining item's lnglat
		const createMarker = (lnglat) => {
			const marker = new mapboxgl.Marker({ color: '#20bb43', draggable: true }).setLngLat(lnglat);
			marker.on('dragend', (e) => {
				const lnglat = e.target._lngLat;
				const lnglatText = lnglat.lng + ',' + lnglat.lat;
				const lnglatInput = {};
				lnglatInput.value = lnglatText;
			});
			return marker;
		};

		/**
		 * See if we have a map_object that already has a point
		 */
		if (map_object && map_object.type === 'Point') {
			map.panTo(map_object.coordinates);
			marker = createMarker(map_object.coordinates);
			marker.addTo(map);
		}

		/**
		 * Handle the click event
		 */
		map.on('click', function (e) {
			const lnglatText = e.lngLat.lng + ' ' + e.lngLat.lat;
			document.getElementById('pointdisplay').innerHTML = lnglatText;
			if (marker) {
				marker.setLngLat(e.lngLat);
			} else {
				marker = createMarker(e.lngLat);
				marker.addTo(map);
			}
			document.getElementById('point_picker_field').value = lnglatText;
		});
	}
});
